import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "animate.css";
import { baseUrl } from "../App";

function Interest() {

  const [received, setReceived] = useState([]);
  const [sent, setSent] = useState([]);
  const [currentUser, setCurrentUser] = useState({});
  const userId = sessionStorage.getItem("userId");
  const navigate = useNavigate();

  useEffect(() => {
    fetchReceived();
    fetchSent();
    fetchCurrentUser();
  }, []);

  const fetchReceived = async () => {
    try {
      const res = await axios.get(
        `${baseUrl}/interest/requested/${userId}`
      );
      setReceived(res.data);
      console.log("requested : ", res.data)
    } catch (error) {
      console.error(error);
    }
  };

  const fetchSent = async () => {
    try {
      const res = await axios.get(
        `${baseUrl}/interest/requester/${userId}`
      );
      setSent(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchCurrentUser = async () => {
    try {
      const res = await axios.get(`${baseUrl}/get/${userId}`);
      setCurrentUser(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleApprove = async (logId) => {
    try {
      await axios.put(
        `${baseUrl}/interest/approve/${logId}`
      );
      fetchReceived();
    } catch (error) {
      console.error(error);
    }
  };

  const handleViewProfile = (id) => {
    navigate(`/userdashboard/view-profile/${id}`);
  };

  return (
    <div className="container mt-4" style={{ position: "relative" }}>

      {/* Payment Verification Overlay */}
      {currentUser.payment_status != 1 && currentUser.payment_status !== "\u0001" && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            zIndex: 1000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <div className="text-center text-white p-4">
            <h3 className="mb-3">Payment Verification Required</h3>
            <p className="mb-0">To explore this feature, please verify your payment in Profile.</p>
          </div>
        </div>
      )}

      <h3 className="text-center fw-bold mb-4">Your Interests ❤️</h3>

      {/* ================= RECEIVED SECTION ================= */}
      <div className="card shadow-sm p-4 mb-5">
        <h5 className="mb-4 text-primary">Interests Received</h5>

        <div className="row">

          {received.length === 0 && (
            <p className="text-muted">No interests received.</p>
          )}

          {received.map((log) => (
            <div key={log.id} className="col-md-6 mb-4">

              <div className="card h-100 shadow-sm border-0 animate__animated animate__fadeIn">

                <div className="card-body">

                  <h5 className="fw-bold">{log.requester?.name}</h5>

                  <p className="text-muted mb-3">
                    Interested on: {log.date}
                  </p>

                  <div className="d-flex justify-content-between align-items-center">

                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => handleViewProfile(log.requester?.id)}
                    >
                      View Profile
                    </button>

                    {!log.approved ? (
                      <button
                        className="btn btn-success btn-sm"
                        onClick={() => handleApprove(log.id)}
                      >
                        Approve
                      </button>
                    ) : (
                      <span className="badge bg-success">
                        Approved ✅
                      </span>
                    )}

                  </div>

                </div>

              </div>

            </div>
          ))}

        </div>
      </div>

      {/* ================= SENT SECTION ================= */}
      <div className="card shadow-sm p-4">
        <h5 className="mb-4 text-success">Interests Sent</h5>

        <div className="row">

          {sent.length === 0 && (
            <p className="text-muted">No interests sent.</p>
          )}

          {sent.map((log) => (
            <div key={log.id} className="col-md-6 mb-4">

              <div className="card h-100 shadow-sm border-0 animate__animated animate__fadeIn">

                <div className="card-body">

                  <h5 className="fw-bold">{log.requested?.name}</h5>

                  <p className="text-muted mb-3">
                    Sent on: {log.date}
                  </p>

                  <div className="d-flex justify-content-between align-items-center">

                    {log.approved ? (
                      <button
                        className="btn btn-outline-primary btn-sm"
                        onClick={() => handleViewProfile(log.requested?.id)}
                      >
                        View Profile
                      </button>
                    ) : (
                      <span className="badge bg-warning text-dark">
                        Pending Approval
                      </span>
                    )}

                  </div>

                </div>

              </div>

            </div>
          ))}

        </div>
      </div>

    </div>
  );
}

export default Interest;
